import inboxIcon from '@/assets/dashboard/inbox.svg'
import coinIcon from '@/assets/dashboard/coin.svg'
import tagIcon from '@/assets/dashboard/tag.svg'
import { Card } from '@/components/ui/card'
import { formatCompactNumber, formatMoney } from '@/utils'
import { StatsCard } from '../stats/StatsCard'
import { ProfileWelcomeCard } from '../ProfileWelcomeCard'
import { BuySellSplit } from '../BuySellSplit'
import TotalProjectsGraph from '../TotalProjectsGraph'
import OrderBookGraph from '../OrderBookGraph'
import AverageDiscountChart from '../AverageDiscountChart'
import { DashboardStatsProps, formatChartData } from './DashboardStatsBase'

/**
 * Desktop version of Dashboard Stats
 * 3-column grid layout with charts
 */
export const DashboardStatsDesktop = ({
  profile,
  totalProjects,
  totalOrderbookValue,
  averageDiscount,
  buyOrders,
  sellOrders,
  loading = false,
  totalProjectsMonthlyAvg,
  orderbookMonthlyAvg
}: DashboardStatsProps) => {
  return (
    <div className="grid grid-cols-3 gap-4 items-stretch">
      {/* Left Column - Profile Welcome Card */}
      <div className="col-span-1">
        <ProfileWelcomeCard profile={profile} />
      </div>

      {/* Middle Column - Total Projects & Average Discount */}
      <div className="col-span-1 flex flex-col space-y-4">
        <StatsCard
          icon={inboxIcon}
          iconAlt="Total Projects"
          label="Total Projects"
          value={formatCompactNumber(totalProjects)}
          loading={loading}
          chart={
            <TotalProjectsGraph 
              data={formatChartData(totalProjectsMonthlyAvg, 3)}
            />
          }
        />
        <StatsCard
          icon={tagIcon}
          iconAlt="Average Discount"
          label="Average Discount"
          value={
            <>
              <span>{averageDiscount.toFixed(1)} </span>
              <span className="text-lg text-foreground/48 align-super">%</span>
            </>
          }
          loading={loading}
          chart={<AverageDiscountChart />}
        />
      </div>

      {/* Right Column - Order Book & Buy/Sell Split */}
      <div className="col-span-1 flex flex-col space-y-4">
        <StatsCard
          icon={coinIcon}
          iconAlt="Order Book"
          label="Order Book"
          value={
            <>
              <span className="text-foreground/48">$</span>
              <span className="text-foreground"> {formatMoney(totalOrderbookValue).replace('$', '').trim()}</span>
            </>
          }
          loading={loading}
          chart={
            <OrderBookGraph 
              data={formatChartData(orderbookMonthlyAvg, 6)}
            />
          }
        />
        <Card variant="default" padding="none" className="bg-white dark:bg-[#1c1c1c] border border-solid border-white dark:border-[#1c1c1c] relative h-[100px] pt-4 pb-2 pl-6 pr-6">
          <BuySellSplit 
            buyCount={buyOrders}
            sellCount={sellOrders}
            className="h-[68px]"
          />
        </Card>
      </div>
    </div>
  )
}

